/*
 * LocationBrands — Section 4/10 for /garage-door-repair-hills-district/
 * MASTER TEMPLATE — duplicate for other locations, change only the LOC block.
 * Paste this ENTIRE file into src/pages/GarageDoorRepairHillsDistrict/sections/LocationBrands.tsx
 */

// ╔══════════════════════════════════════════════════════════════════╗
// ║  LOC CONFIG — change ONLY this block when duplicating          ║
// ╚══════════════════════════════════════════════════════════════════╝
const LOC = {
  name: "Hills District",
  h2: "We Service Every Brand in the Hills District",
  subtitle: "Whatever\'s in your garage — B&D, Merlin, ATA or Steel-Line — we carry the parts and know the systems."
};
// ╚══════════════════════════════════════════════════════════════════╝

const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const CREAM = "#FAF7F1";
const CREAM2 = "#F0EBE0";
const INK = "#1A1F2E";
const INK2 = "#5A6478";
const NAVY = "#081438";
const BRANDS = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/b5706f1be_58dae4e4d_BD_Australia_Logo.webp",
  alt: "B&D Australia"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/24bd15fa9_a095621ff_Merlin-Logo-Positive.webp",
  alt: "Merlin"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/7656bc9c2_c348bc03e_gliderol-logo.webp",
  alt: "Gliderol"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/liftmaster.webp",
  alt: "LiftMaster"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/steel-line-garage-doors.webp",
  alt: "Steel-Line"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/marantec.webp",
  alt: "Marantec"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/doors-industrial.webp",
  alt: "4D Industrial"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/grifco.png",
  alt: "Grifco"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/ata-logo-min-300x226.png.webp",
  alt: "ATA"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/5e385702d_6c94e3d82_superliftlogo-1.png",
  alt: "Superlift"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/centurion-garage-doors.webp",
  alt: "Centurion"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/doors-industrial.webp",
  alt: "4 Doors"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/hormann.webp",
  alt: "Hormann"
}];
const MARQUEE = [...BRANDS, ...BRANDS];
export default function LocationBrands() {
  return <section id="location-brands" style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden"
  }}>

      {/* Wave top — DUPLICATE from LocationServices bottom */}
      <div style={{
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        width: "100%",
        display: "block"
      }}>
          <path d="M0,60 C360,0 1080,0 1440,60 L1440,0 L0,0 Z" fill={NAVY} />
        </svg>
      </div>

      {/* Paper grain */}
      <svg aria-hidden="true" style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.04,
      pointerEvents: "none",
      zIndex: 1
    }}>
        <filter id="lb-grain"><feTurbulence type="fractalNoise" baseFrequency="0.75" numOctaves="4" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter>
        <rect width="100%" height="100%" filter="url(#lb-grain)" />
      </svg>

      {/* Corner ornaments */}
      <div aria-hidden="true" style={{
      position: "absolute",
      top: "40px",
      left: "40px",
      width: "64px",
      height: "64px",
      borderTop: `2px solid ${GOLD}50`,
      borderLeft: `2px solid ${GOLD}50`,
      zIndex: 1
    }} />
      <div aria-hidden="true" style={{
      position: "absolute",
      bottom: "40px",
      right: "40px",
      width: "64px",
      height: "64px",
      borderBottom: `2px solid ${GOLD}50`,
      borderRight: `2px solid ${GOLD}50`,
      zIndex: 1
    }} />

      <div style={{
      position: "relative",
      zIndex: 2,
      maxWidth: "1280px",
      margin: "0 auto",
      padding: "clamp(56px,7vw,80px) clamp(20px,5vw,48px)"
    }}>

        {/* Header */}
        <div style={{
        textAlign: "center",
        marginBottom: "44px"
      }}>
          <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px"
        }}>
            <div style={{
            width: "32px",
            height: "2px",
            background: GOLD
          }} />
            <span style={{
            fontFamily: "Manrope,sans-serif",
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: GOLD_DARK
          }}>
              All Major Brands
            </span>
            <div style={{
            width: "32px",
            height: "2px",
            background: GOLD
          }} />
          </div>
          <h2 style={{
          fontFamily: "Plus Jakarta Sans,sans-serif",
          fontWeight: 800,
          fontSize: "clamp(24px,3vw,38px)",
          lineHeight: 1.1,
          color: INK,
          marginBottom: "12px"
        }}>
            {LOC.h2}
          </h2>
          <p style={{
          fontFamily: "Manrope,sans-serif",
          fontSize: "clamp(14px,1.5vw,16px)",
          color: INK2,
          lineHeight: 1.7,
          maxWidth: "520px",
          margin: "0 auto"
        }}>
            {LOC.subtitle}
          </p>
        </div>

        {/* Logo grid */}
        <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(120px,1fr))",
        gap: "12px",
        marginBottom: "44px"
      }}>
          {BRANDS.map(b => <div key={b.alt} style={{
          background: "#FFFFFF",
          border: `1px solid ${CREAM2}`,
          borderRadius: "10px",
          padding: "18px 12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "64px",
          boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
          transition: "border-color 0.2s"
        }} className="hover:!border-[#F5A623]/50">
              <img src={b.src} alt={b.alt} width={100} height={32} loading="lazy" decoding="async" style={{
            height: "28px",
            width: "auto",
            objectFit: "contain",
            opacity: 0.6,
            transition: "opacity 0.3s"
          }} className="hover:!opacity-100" />
            </div>)}
        </div>

        {/* Marquee */}
        <div style={{
        position: "relative",
        overflow: "hidden"
      }}>
          <div style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "80px",
          background: `linear-gradient(90deg,${CREAM},transparent)`,
          zIndex: 2,
          pointerEvents: "none"
        }} />
          <div style={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: "80px",
          background: `linear-gradient(270deg,${CREAM},transparent)`,
          zIndex: 2,
          pointerEvents: "none"
        }} />
          <div style={{
          display: "flex",
          alignItems: "center",
          width: "max-content",
          animation: "lb-scroll 35s linear infinite"
        }} className="hover:[animation-play-state:paused]">
            {MARQUEE.map((b, i) => <img key={`${b.alt}-${i}`} src={b.src} alt={b.alt} width={120} height={32} loading="lazy" decoding="async" style={{
            height: "24px",
            width: "auto",
            objectFit: "contain",
            padding: "0 20px",
            flexShrink: 0,
            opacity: 0.35,
            transition: "all 0.4s"
          }} className="hover:!opacity-100 hover:!scale-105" />)}
          </div>
        </div>

        <style>{`
          @keyframes lb-scroll {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>

        {/* Bottom note */}
        <p style={{
        fontFamily: "Manrope,sans-serif",
        fontSize: "13px",
        color: INK2,
        textAlign: "center",
        marginTop: "28px"
      }}>
          Not sure about your brand? <a href="tel:0485000933" style={{
          color: GOLD_DARK,
          fontWeight: 700,
          textDecoration: "none"
        }}>Call us</a> — if it's a garage door, we fix it.
        </p>
      </div>

      {/* Wave bottom — DUPLICATE in LocationProcess top */}
      <div style={{
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        width: "100%",
        display: "block"
      }}>
          <path d="M0,0 C360,60 1080,60 1440,0 L1440,60 L0,60 Z" fill={NAVY} />
        </svg>
      </div>
    </section>;
}